<template>
  <div class="InspirationMediaItem w-full inline-block">
    <span></span>
    <NuxtLink
      class="w-full overflow-hidden bg-white"
      :to="url"
      @click.native="trackClick"
    >
      <img
        v-if="media?.photo"
        v-lazy-load :data-src="photoSrc"
        :alt="`${media.title} - ${media.description}`"
        class="object-cover w-full h-[280px] md:h-[320px] rounded-md block"
        @error="$helpers.noImage"
      />
      <video
        v-else-if="media?.videoFileName"
        ref="videoPlayer"
        v-lazy-load :data-src="videoSrc"
        class="w-full h-80 object-cover rounded-t-md"
        muted
        loop
        playsinline
      />
    </NuxtLink>
    <NuxtLink :to="url" class="w-full text-black" @click.native="trackClick">
      {{ media.title }}
    </NuxtLink>
  </div>
</template>

<script>
export default {
  name: "InspirationMediaItem",
  props: {
    media: {
      type: Object,
      required: true,
    },
    inspiration: {
      type: Object,
      required: true,
    },
  },
  computed: {
    url() {
      return this.localePath({
        name: "inspirationPicturePage",
        params: {
          inspirationSeoName: this.inspiration.seoName,
          pictureSeoName: this.media.seoName,
        },
      });
    },
    photoSrc() {
      return this.$helpers.getReferencePhoto(this.media?.photo?.name);
    },
    videoSrc() {
      return this.$helpers.getInspirationVideo(this.media?.videoFileName);
    },
  },
  mounted() {
    setTimeout(() => {
      const videoElement = this.$refs.videoPlayer;
      if (videoElement) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                return videoElement.play();
              }

              videoElement.pause();
            });
          },
          { threshold: 0.5 }
        );

        observer.observe(videoElement);
      }
    }, 300);
  },
  methods: {
    trackClick() {
      this.$trackers.trackClick("InspirationMediaItem", {
        clickedPictureSeoName: this.media.seoName,
        clickedPictureId: this.media.id,
      });
    },
  },
};
</script>
